
import { ChannelkartNetworkGet } from "./networkService";



export async function fetchHistoricalSyncSummary(env : string, lob : string ){
    // // 
 try{
  const response = await ChannelkartNetworkGet(`https://analytics.sellina.io/historicalSyncStatus?env=${env}&lob=${lob}`);
  // const response = await ChannelkartNetworkGet(`http://localhost:3001/historicalSyncStatus?env=local&lob=kbpldemo&source=portal`);
  
   if(response.data){
    const groupedData = groupByGroupId(response.data.data);
    let tableWiseGroup = fetchTableWiseData(groupedData);
    let overAllStatus = fetchOverAllStatus(groupedData);
    
    return {
        tableWise: tableWiseGroup,
        overAllStatus : overAllStatus
      };
    }
   return {
    tableWise: [],
    overAllStatus : [] 
  };
  }catch(err){
    return {
        tableWise: [],
        overAllStatus : [] 
      };
  }
}

const groupByGroupId = (data: any[]) => {
    const grouped: Record<
      string,
      { group_Id: string; taskDate: string; groupItems: any[] }
    > = {};
  
    data.forEach((record) => {
      const key = `${record.group_id}`;
  
      if (!grouped[key]) {
        grouped[key] = {
          group_Id: record.group_id,
          taskDate: new Date(record.taskdate).toISOString().split("T")[0],
          groupItems: [],
        };
      }
  
      grouped[key].groupItems.push(record);
    });
    return grouped;
   
  };

  function fetchTableWiseData(grouped: Record<
    string,
    { group_Id: string; taskDate: string; groupItems: any[] }
  >) {
    return Object.values(grouped).map((group) => {
      // Determine status based on group items
      const hasErrors = group.groupItems.some(item => item.status !== "Success");
      const status = hasErrors ? "Failed" : "Success";
      
      return {
        group_Id: group.group_Id,
        taskDate: group.taskDate,
        groupItems: JSON.stringify(group.groupItems),
        status: status
      };
    }).sort((a, b) => new Date(b.taskDate).getTime() - new Date(a.taskDate).getTime());
  }
  function fetchOverAllStatus(grouped: Record<
    string,
    { group_Id: string; taskDate: string; groupItems: any[] }
  >) {
    const today = new Date().toISOString().split("T")[0];
  
    return Object.values(grouped)
      .filter(group => group.taskDate === today)
      .map((group) => {
        const summary = generateGroupSummary(group.groupItems);
        return {
          group_Id: group.group_Id,
          taskDate: group.taskDate,
          ...summary
        };
      });
  }
  
  const generateGroupSummary = (groupItems: any[]) => {
    let mysqlTotal = 0;
    let redshiftTotal = 0;
    let s3Total = 0;
    let mysqlDifference = 0;
    let s3Difference = 0;
  
    groupItems.forEach((item) => {
      const mysql = Number(item.totalexternalrecords) || 0;
      const s3 = Number(item.totals3records) || 0;
      const redshift = Number(item.totalredshiftrecords) || 0;
  
      mysqlTotal += mysql;
      s3Total += s3;
      redshiftTotal += redshift;
  
      mysqlDifference += mysql - s3;
      s3Difference += s3 - redshift;
    });
  
    return {
      mysqlTotal,
      redshiftTotal,
      s3Total,
      mysqlDifference,
      s3Difference,
    };
  };
    